import { FormattedMessage } from 'react-intl';
import { Button, ButtonProps } from '@mui/material';

import SyncButtonIcon from './SyncButtonIcon';

type Props = {
  buttonText?: JSX.Element;
  onClick: () => void;
  sx?: ButtonProps['sx'];
};

/**
 * Sync button for free trial modal
 * @param props Component props
 * @returns React component
 */
const SyncButtonWithModal = ({ buttonText, onClick, sx }: Props) => (
  <Button
    variant="outlined"
    color="primary"
    size="small"
    startIcon={<SyncButtonIcon state="connected" />}
    onClick={onClick}
    sx={sx}
  >
    {buttonText || <FormattedMessage defaultMessage="Sync" />}
  </Button>
);

export type { Props as SyncButtonWithModalProps };
export default SyncButtonWithModal;
